import {
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import { RootState } from '../store/store';
import { logout, setCredentials } from '../store/auth.slice';

/** Эндпоинты с телом FormData: boundary ставит браузер, Content-Type задавать нельзя. */
const multipartEndpoints = ['uploadCatalogProfilePhoto', 'uploadPsychologistAvatar'];

/** Базовый query psychologist-service: Bearer-токен, JSON и повтор запроса после refresh по 401. */
export const createPsychologistServiceBaseQuery = (
  serviceBaseUrl: string,
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = fetchBaseQuery({
    baseUrl: serviceBaseUrl,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).authSlice.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      if (!multipartEndpoints.includes(endpoint)) {
        headers.set('Content-Type', 'application/json');
      }
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {
      const refreshToken = (api.getState() as RootState).authSlice.refreshToken;
      try {
        const refreshResult = await fetchBaseQuery({ baseUrl: serviceBaseUrl })(
          { url: '/token/refresh', method: 'POST', body: JSON.stringify({ refresh_token: refreshToken }) },
          api,
          extraOptions,
        );
        if (refreshResult.data) {
          api.dispatch(setCredentials(refreshResult.data as { token: string; refresh_token: string }));
          result = await baseQuery(args, api, extraOptions);
        } else {
          api.dispatch(logout());
        }
      } catch {
        api.dispatch(logout());
      }
    }

    return result;
  };
};
